import { PresenceStack } from "@components/avatar/PresenceStack";
import { useWorkAgentRun, useWorkViewers } from "../board/useWorkCardPresence";
import { getWorkRowPresenceMembers } from "../board/workCardPresence";
import type { ClientsWorkOverviewWorkRow } from "../clientsWorkOverviewViewConfig";

/**
 * A work row's presence stack, after its Service name: the board card's
 * stack without the team members who aren't viewing, since the Engagement
 * team column shows them.
 */
export const WorkRowPresence = ({
    row,
}: {
    row: ClientsWorkOverviewWorkRow;
}) => {
    const { isAgentWorking } = useWorkAgentRun(row);
    const viewers = useWorkViewers(row);
    return (
        <PresenceStack
            members={getWorkRowPresenceMembers({
                row,
                isAgentWorking,
                viewers,
            })}
        />
    );
};
